import axios from './api';

export const getUserSelectCaseList = () => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserSelectCaseList',
  })
);

export const getUserSelectPlanList = (params:any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserSelectPlanList',
    params,
  })
);
